import { StaticModal, createModal } from '@nexelem/modals';
import { Button } from '@nexelem/components';
import { useDateFormatter } from '@nexelem/utils';
import { FormProvider, useForm } from 'react-hook-form';
import { Trans } from 'react-i18next';
import { useCustomTranslation } from '../../../../../hooks';
import { FormSelectInput } from '@nexelem/form-components';
import { SingleDetail } from '../../../../atoms/SingleDetail';
import { z } from 'zod';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarRange } from '@fortawesome/pro-light-svg-icons';

const schema = z.object({
  queueName: z.string().min(1),
  possibleStart: z.date(),
  possibleEnd: z.date(),
  productionOrderDueDate: z.date(),
});

export type ToDoPlannedModalSchema = z.infer<typeof schema>;

// remove export from the modal
const KanbanToDoPendingModal = () => {
  const { tWrapper } = useCustomTranslation('products.productionPlan.kanban.modals.todoPlanned');
  const { tWrapper: inputTWrapper } = useCustomTranslation('products.productionPlan.kanban.modals.inputLabels');

  const formatDate = useDateFormatter({ displayWithHours: true });

  const { handleSubmit, ...form } = useForm<ToDoPlannedModalSchema>({
    // TODO: uncomment when BE will be ready
    // resolver: zodResolver(getSchema()),
    defaultValues: {
      queueName: '',
      possibleStart: new Date(),
      possibleEnd: new Date(),
      productionOrderDueDate: new Date(),
    },
  });

  const onSubmit = (/*data: TODOPlannedModalSchema*/) => {
    // TODO: Implement the logic for adding task to plan
    // onConfirm();
  };

  return (
    <StaticModal isOpen component="form" onClose={closeKanbanToDoPendingModal} onSubmit={handleSubmit(onSubmit)}>
      <StaticModal.Header withCloseButton>{tWrapper('header')}</StaticModal.Header>
      <StaticModal.Content>
        <FormProvider {...form} handleSubmit={handleSubmit}>
          <div className="flex flex-col gap-y-6">
            {/* <LotInfo active={action.active} /> */}
            <span className="text-s18">
              <Trans components={{ strong: <strong /> }}>{tWrapper('description')}</Trans>
            </span>
            <FormSelectInput
              required
              label={inputTWrapper('queueName')}
              name="queueName"
              placeholder={inputTWrapper('queueNamePlaceholder')}
              options={
                [
                  /* TODO: wait for BE */
                ]
              }
            />
            <div className="flex gap-6">
              <div className="flex items-center gap-4">
                <SingleDetail
                  title={tWrapper('possibleStart')}
                  content={
                    <div className="flex items-center gap-2">
                      <FontAwesomeIcon className="text-icon-primary" icon={faCalendarRange} />
                      {formatDate(new Date())}
                    </div>
                  }
                />
                <SingleDetail
                  title={tWrapper('possibleEnd')}
                  content={
                    <div className="flex items-center gap-2">
                      <FontAwesomeIcon className="text-icon-primary" icon={faCalendarRange} />
                      {formatDate(new Date())}
                    </div>
                  }
                />
              </div>
            </div>
            <SingleDetail content={formatDate(new Date())} title={inputTWrapper('productionOrderDueDate')} />
          </div>
        </FormProvider>
      </StaticModal.Content>
      <StaticModal.Footer>
        <Button variant="outlined" onClick={closeKanbanToDoPendingModal}>
          {tWrapper('cancel')}
        </Button>
        <Button type="submit" variant="contained" onClick={handleSubmit(onSubmit)}>
          {tWrapper('confirm')}
        </Button>
      </StaticModal.Footer>
    </StaticModal>
  );
};

// export the modal using createModal
export const { openKanbanToDoPendingModal, closeKanbanToDoPendingModal } = createModal(KanbanToDoPendingModal, {
  name: 'KanbanToDoPendingModal',
});
